import React, { useEffect, useRef } from 'react';
import { LineChart, PieChart, ColumnChart } from '@toast-ui/chart';
import '@toast-ui/chart/dist/toastui-chart.min.css';

const CustomChart = ({ type, data, options }) => {
    const chartContainerRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (chartContainerRef.current) {
            if (chartContainerRef.current?.offsetHeight === 0) {
                chartContainerRef.current.style.height = '600px';
            }

            if (chartInstance.current) {
                chartInstance.current.destroy();
                chartInstance.current = null;
            }

            try {
                const updatedOptions = {
                    ...options,
                    legend: {
                        visible: data.series.length <= 8, // 레전드 항목이 8개 이하일 때만 표시
                        align: 'center',
                    },
                };

                if (type === 'line') {
                    chartInstance.current = new LineChart({
                        el: chartContainerRef.current,
                        data,
                        options: updatedOptions,
                    });
                } else if (type === 'pie') {
                    chartInstance.current = new PieChart({
                        el: chartContainerRef.current,
                        data,
                        options: updatedOptions,
                    });
                } else if (type === 'bar') {
                    chartInstance.current = new ColumnChart({
                        el: chartContainerRef.current,
                        data,
                        options: updatedOptions,
                    });
                } else {
                }
            } catch (error) {
            }
        }

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
                chartInstance.current = null;
            }
        };
    }, [type, data, options]);

    return (
        <div
            ref={chartContainerRef}
            style={{
                width: "100%",
                height: "100%",
            }}
        ></div>
    );
};

export default CustomChart;

